import React from 'react';

// A non-input sub-section title row. It holds no form value and posts nothing;
// visibility is controlled by the parent QuoteBuilderForm via config.visible_if.
// Used to group fields into labelled sub-sections (for example the Glue and Tape
// sub-sections shown when the glueing type is "Glue & Tape").
const HeadingFormField = ({ config }) => {
  return (
    <tr className="quote-builder-subsection-heading">
      <th colSpan="2">
        {t(config.label)}
      </th>
    </tr>
  )
}

export default HeadingFormField;
